var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-footer bg-lightest"},[_c('div',{staticClass:"table-footer__row-count bg-medium"},[_vm._v(" "+_vm._s(_vm.rowCount)+" ")]),_c('div',{staticClass:"table-footer__additional-info"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }